/* const cartButtons = document.getElementById("product-form");
if (cartButtons) {
  cartButtons.remove();
}
*/

const jsonDataElement = document.getElementById("custom-pattern-data");
console.log("jsonDataElement", jsonDataElement);

const patternData = JSON.parse(jsonDataElement.textContent);

class CustomPattern extends HTMLElement {
  constructor() {
        super();
        this.shopifyDomain = "sensy-tr.myshopify.com";
        this._bundleData = {};
        this.transformedData = []; // this will include a list of variants to post cart/add for add to cart functionality
        this.variantList = []; // this will include a list of variants to post cart/add for add to cart functionality 
        // {id: variantId, quantity: selectedQuantity, quantityNeeded: neededQuantity, inventory: availableForSale}
        this.quantityNeeded = {};
        // TODO: transformedData will be mutated by selecting another variant which is fetched by clicking change color button and opening a modal to choose another variant.
        this.productId = this.dataset.product_id;

        this.style.fontSize = "14px";
        this.style.lineHeight = 1.2;

        this.selectedProductId = "";
        this.selectedVariantId = "";
        this.selectedVariantIndex = 0;
        this.selectedProductType = "";
        this.modal = "";
        this.modalOpen = false;

        this.totalQuantityState = 0;

        this._data = patternData;
        console.log("this._data: ", this._data);
        this._products = [];
        this._bundleData = prepareBundleData(patternData);
        this._bundleData.skillType = {name: this.dataset.skillType || "undefined", slug: this.dataset.skillType || "undefined", imgUrl: this.dataset.skillTypeIcon  || ""};
        this._bundleData.skillLevel = {name: this.dataset.skillLevel || "undefined", slug: this.dataset.skillLevel || "undefined"};
        console.log("this._bundleData", this._bundleData)
         
    }

   connectedCallback() {
        const groupedVariants = this.groupVariantsByType(this._data);
        console.log("groupedVariants: ", groupedVariants);
        this._data.forEach(item => {
            this._products.push(item.product);
        })
        console.log("products: ", this._products);
        this.transformedData = transformShopifyData(this._products);
        console.log("transformedData: ", this.transformedData);
       console.log("this.variantList",this.variantList)

        this.renderBundle();
        this.initializeModal();
    }

    groupVariantsByType(data) {
      const groupedVariants = data.reduce((acc, item) => {
          const group = item.productType === "accessory" ? "accessories" : "others";
          
          if (!acc[group]) {
              acc[group] = [];
          }
          
          acc[group].push({
              proId: item.productId,
              varId: item.variantId,
              quantity: item.quantity,
              needed: item.needed,
              inventory: item.inventory,
              productType: item.productType,
              varImg: item.varImg || null,
              proImg: item.proImg,
              proTitle: item.proTitle,
              varTitle: item.varTitle,
              price: item.price,
              compareAtPrice: item.compareAtPrice,
              handle: item.handle
          });

          return acc;
      }, {});

      this.setVariantList(groupedVariants);
  
      return groupedVariants;
  }

    renderBundle() {

        this.innerHTML = `
            ${this._bundleData.products?.length > 0 ? `
            <div class="custom-bundle-app" id="custom-bundle-app">
                ${this._bundleData.skillLevel?.slug !== "undefined" || this._bundleData.skillType.slug !== "undefined" ? `
                <div class="sensy-project-infos" style="text-transform:uppercase">
                    ${this._bundleData.skillLevel?.slug !== "undefined" ? `
                    <span class="project-skill-level"> Seviye: <span style="font-weight:bold">${this._bundleData.skillLevel?.name}</span></span>
                    ` : ""}
                    ${this._bundleData.skillLevel?.slug !== "undefined" && this._bundleData.skillType.slug !== "undefined" ? `|` : ""}
                    ${this._bundleData.skillType?.slug !== "undefined" ? `
                    <span class="project-technique">Teknik: <img src="${this._bundleData.skillType.imgUrl}" alt="" width="22" height="22"> 
                    <span style="font-weight:bold">${this._bundleData.skillType.name}</span></span>
                    ` : ""}
                </div>
                ` : ""}
                <div class="custom-bundle-title">Deseninizi Özelleştirin</div>
                <div class="custom-bundle-products">
                ${this.variantList.others &&
                    this.variantList.others.length > 0 ? `
                <div class="custom-variants">
                            <div class="custom-title-wrapper"> 
                                <div class="custom-title-icon">
                                    <svg width="27px" height="27px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="#555555" d="M338.6 27.83c-8.1-.03-14.8 2.23-20.9 6.37-19.1 12.88-32.9 49.62-39.4 103.4l10.7 9c15.1-43.5 29.9-88.7 57.2-118.14-2.7-.42-5.2-.63-7.6-.63zm27.3 6.7C338.2 60.14 321.3 109.5 303.8 159l10.8 9.1c11.2-24 22.3-49.1 35.1-71.07 11.5-19.85 24.5-37.4 41.2-48.43-9.1-6.1-17.4-10.75-25-14.07zm40.8 25.68c-15.2 7.85-28.7 24.06-41 45.09 26.3-16.06 44.7-24.41 59.7-29.18-3.3-3.05-6.8-6.16-10.6-9.33-2.7-2.31-5.4-4.49-8.1-6.58zm33.4 30.48c-19 4.43-42.7 14.21-91.3 46.91-3.3 6.7-6.4 13.5-9.6 20.3 39.6-19 81.7-41.1 119.1-43.4-4.3-7.3-10.3-15.29-18.2-23.81zm24.8 41.71c-6 0-12.5.9-19.4 2.4-7.4 9-12.5 21.3-15 33.7-1.5 7.1-2 14.3-1.9 20.7 18.1-10.2 30.1-21.1 35.1-32.4 3.4-7.5 4.3-15.3 2.1-24.4h-.9zm-45 9.9c-9.4 3.4-19.3 7.5-29.4 11.9-10.4 20.1-14.8 39.9-15.2 57.2 13.2-4.2 25.1-8.7 35.7-13.4-1.2-10-.6-21.4 1.8-33.1 1.5-7.6 3.9-15.2 7.1-22.6zM269.8 154l-19.3 23 84.2 70.7 19.3-23-84.2-70.7zm96.3 11.3c-11.8 5.5-23.6 11.1-35.3 16.4l26.9 22.5c.9-12.4 3.6-25.5 8.4-38.9zm-127.2 25.5l-50.1 59.7 84.3 70.7 50.1-59.7-84.3-70.7zm178.3 24.6c-10.4 4.5-21.9 8.7-34.2 12.6 8.2.9 18.7 2.4 29.4 4.8 11.2 2.5 22.4 6.2 30.3 10.6 7.9 4.5 11.8 9.1 12.4 13.7v.1c.8 6.3-.4 10.8-3.2 15.2-2.8 4.4-7.6 8.7-14.1 12.8-13.2 8-33.1 14.5-53.7 21-20.5 6.6-41.8 13.1-58.8 22.9-17 9.9-30.6 24.7-30.3 45.1.2 19.1 11.8 35.5 27.1 49.2 15.3 13.7 34.8 25.3 54.2 34.9 38.8 19.1 77.2 30.3 77.2 30.3l5-17.2s-37.2-10.9-74.2-29.3c-18.5-9.1-36.9-20.2-50.2-32.1-13.3-12-20.9-24.3-21.1-36-.2-12.8 7.1-21 21.3-29.3 14.3-8.2 34.7-14.8 55.3-21.3 20.6-6.5 41.4-13 57.6-22.9 8-4.9 15.1-10.8 19.9-18.5 4.9-7.6 7.1-17.1 5.8-27.1-1.6-12.5-10.8-21.2-21.3-27.2-10.2-5.8-22.4-9.5-34.4-12.3zm-239.9 48.9l-19.3 23 84.2 70.7 19.3-23-84.2-70.7zm-40.6 36.3c-13.2 4.2-25.2 8.7-35.7 13.4 1.2 10 .6 21.4-1.83 33.1-1.55 7.6-3.88 15.3-7.14 22.6 9.47-3.4 19.37-7.5 29.47-11.9 10.4-20.1 14.8-39.9 15.2-57.2zm17.6 7.2c-.9 12.4-3.6 25.5-8.4 38.9 11.8-5.5 23.6-11.1 35.2-16.4l-5.2-4.4-21.6-18.1zm-70.85 15c-18.08 10.2-30.14 21.1-35.17 32.4-3.35 7.5-4.27 15.3-2.07 24.4 6.27.1 13.1-.8 20.37-2.4 7.37-9 12.44-21.3 14.96-33.7 1.47-7.1 2.03-14.3 1.91-20.7zm113.95 21.1c-11.2 24-22.3 49.1-35.1 71.1-11.5 19.8-24.5 37.3-41.1 48.4 9 6.1 17.3 10.7 24.9 14.1 27.7-25.6 44.6-75 62.1-124.5l-10.8-9.1zm-24.6 10.2c-39.6 19-81.77 41.1-119.05 43.4 4.28 7.3 10.29 15.3 18.15 23.8 19.08-4.4 42.7-14.3 91.3-46.9 3.3-6.7 6.4-13.5 9.6-20.3zm50.2 11.3c-15.1 43.5-29.9 88.7-57.2 118.1 11.6 1.9 20.5-.3 28.5-5.7 19.1-12.9 32.9-49.6 39.4-103.4l-10.7-9zm-76.7 41.3c-26.3 16.1-44.7 24.4-59.73 29.1 3.35 3.1 6.88 6.2 10.67 9.4 2.75 2.3 5.46 4.5 8.06 6.6 15.2-7.9 28.7-24 41-45.1z"/></svg>
                                </div>
                                <div class="custom-title">
                                    İplik Seçin
                                </div>
                            </div>
                            <ul class="custom-variant-list">
                                ${this.renderProducts(this.variantList.others)}
                            </ul>
                        </div>
                ` : ``}
                ${this.variantList.accessories &&
                    this.variantList.accessories?.length > 0 ? `
                <div class="custom-accessories">
                            <div class="custom-title-wrapper"> 
                                <div class="custom-title-icon">
                                    <svg fill="#555555" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                        viewBox="0 0 512 512" xml:space="preserve">
                                        <g>
                                            <g>
                                                <path d="M428.522,0c-46.03,0-83.478,37.448-83.478,83.478c0,16.99,5.113,32.801,13.865,46.001L4.891,483.499
                                                    c-6.52,6.52-6.52,17.091,0,23.611c3.259,3.26,7.532,4.89,11.805,4.89c4.273,0,8.546-1.63,11.805-4.891L382.52,153.09
                                                    c13.2,8.753,29.013,13.866,46.002,13.866c46.03,0,83.478-37.448,83.478-83.478S474.552,0,428.522,0z"/>
                                            </g>
                                        </g>
                                        <g>
                                            <g>
                                                <path d="M153.091,129.479c8.752-13.2,13.865-29.011,13.865-46.001C166.957,37.448,129.508,0,83.478,0S0,37.448,0,83.478
                                                    s37.448,83.478,83.478,83.478c16.99,0,32.801-5.113,46.002-13.866l79.298,79.298l23.611-23.611L153.091,129.479z"/>
                                            </g>
                                        </g>
                                        <g>
                                            <g>
                                                <path d="M507.109,483.498L303.222,279.611l-23.611,23.611l203.887,203.887c3.26,3.261,7.533,4.891,11.806,4.891
                                                    c4.273,0,8.546-1.63,11.805-4.891C513.629,500.589,513.629,490.018,507.109,483.498z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                <div class="custom-title">
                                    Aksesuar Seçin
                                </div>
                            </div>
                            <ul class="custom-variant-list">
                                ${this.renderProducts(this.variantList.accessories)}
                            </ul>
                        </div>
                ` : ``}   
                </div>
                <div class="total-price">
                    <div class="total-price-label">Toplam:</div>
                    <div class="total-price-amount">₺${this.getTotalPrice().toFixed(2).toString()}</div>
                </div>
                <div class="add-to-cart">
                    <form method="post" action="/cart/add" 
                    id="form-product-grouped" accept-charset="UTF-8" 
                    class="form" enctype="multipart/form-data" 
                    novalidate="novalidate" data-type="add-to-cart-form">
                        <button id="sensy-add-to-cart" class="relative flex-1 whitespace-nowrap min-height-48 mb-15 mr-10 animation flash-move" type="submit">
                        <span class="hidden-loading">Sepete Ekle</span>
                        <span class="loader-icon"></span>
                        </button>
                    </form>
                </div>
            </div>
            ` : ""}
            
        `

        const addToCartButton = document.getElementById('sensy-add-to-cart');
        addToCartButton.disabled = this.getTotalQuantity() === 0;
        addToCartButton.addEventListener('click', (e) => this.addToCart(e, this.variantList));
        //! this will be delete later
        // addToCartButton.addEventListener('click', (e) => this.submitProductGroup(e));

       /* const quantityButtons = document.querySelectorAll('.quantity_button_custom');
        console.log("quantityButtons", quantityButtons)
          quantityButtons.forEach(qBtn => {
              qBtn.addEventListener('click', (e) => {
                  e.stopPropagation();
                  
                  const inputElement = qBtn.id === "custom-plus" ? qBtn.previousElementSibling : qBtn.nextElementSibling;
  
                  if (inputElement && inputElement.tagName === 'INPUT') {
                      const currentValue = parseInt(inputElement.value);
                      if (!isNaN(currentValue)) {
                          inputElement.value = qBtn.id === "custom-plus" ? Math.min(inputElement.max, currentValue + 1) : Math.max(0, currentValue - 1);
                      }
                  }
                
              });
          });
        */
        const quantityItems = document.querySelectorAll('.quantity-item');
      console.log("quantityItems", quantityItems)
        quantityItems.forEach(input => {
            input.addEventListener('change', (e) => {
                this.selectedProductType = e.target.dataset.type;
                let quantity = Number(e.target.value);
                console.log("this.selectedProductType", this.selectedProductType);
                console.log("quantity", quantity);
                this.handleQuantityChange(e.target.dataset.index, quantity);
            })
        });

        const changeColorButtons = document.querySelectorAll('.custom-bundle-change-color');
        changeColorButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                this.modal.style.display = 'block';
                this.selectedVariantId = e.target.dataset.varId;
                this.selectedProductId = e.target.parentElement.dataset.proId;
                this.selectedVariantIndex = e.target.dataset.variantIndex;

                this.updateModalContent()
            })
        });
    }

    renderProducts(variantList) {
        let variantListHtml = "";
        variantList.forEach((variant, index) => {
            variantListHtml += `
                                <li class="custom-list-item">
                                    <div class="custom-list-item-left">
                                    <div class="custom-bundle-product-image-container">
                                        ${variant.varImg || variant.proImg ? `
                                        <img src="${variant.varImg || variant.proImg}" alt="">
                                        ` : `
                                        <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path d="M12.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"></path><path fill-rule="evenodd" d="M9.018 3.5h1.964c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2v1.964c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043h-1.964c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47-.043-.531-.043-1.187-.043-2v-1.964c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365.531-.043 1.187-.043 2-.043Zm-1.877 1.538c-.454.037-.715.107-.912.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v1.428l.723-.867a1.75 1.75 0 0 1 2.582-.117l2.695 2.695 1.18-1.18a1.75 1.75 0 0 1 2.604.145l.216.27v-2.374c0-.852 0-1.447-.038-1.91-.037-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.984-.984c-.197-.1-.458-.17-.912-.207-.462-.037-1.056-.038-1.909-.038h-1.9c-.852 0-1.447 0-1.91.038Zm-2.103 7.821a7.12 7.12 0 0 1-.006-.08.746.746 0 0 0 .044-.049l1.8-2.159a.25.25 0 0 1 .368-.016l3.226 3.225a.75.75 0 0 0 1.06 0l1.71-1.71a.25.25 0 0 1 .372.021l1.213 1.516c-.021.06-.045.114-.07.165-.216.423-.56.767-.984.983-.197.1-.458.17-.912.207-.462.037-1.056.038-1.909.038h-1.9c-.852 0-1.447 0-1.91-.038-.453-.037-.714-.107-.911-.207a2.25 2.25 0 0 1-.984-.984c-.1-.197-.17-.458-.207-.912Z"></path></svg>
                                        ` }
                                    </div>
                                    <div class="product-info" data-pro-id="${variant.proId}">
                                        <span class="variant-name">${variant.varTitle} </span>
                                        <span class="custom-bundle-change-color" 
                                        data-variant-index=${index} data-var-id="${variant.varId}">Değiştir</span>
                                        <a href="/products/${variant.handle}?variant=${variant.varId}" target="_blank" class="product-name">${variant.proTitle}
                                            ${variant.varTitle ? ` | ${variant.varTitle}` : ""}
                                         </a>
                                        ${this.renderLabels(variant.inventory, variant.quantity, variant.needed)}
                                    </div>
                                    </div>
                                    <div class="custom-list-item-right">
                                        <div class="quantity-wrapper">
                                            <div class="product-form__input quantity-product-group product-form__quantity">
                                                <label class="form__label visually-hidden" for="Quantity-product-grouped">
                                                    QTY
                                                </label>
                                                <quantity-input class="quantity border px-8 flex align-items-center text-center ">
                                                    <button class="btn-reset flex justify-content-center align-items-center quantity_button_custom no-js-hidden width-35" name="minus" id="custom-minus" type="button">
                                                        <svg width="11" height="12" viewBox="0 0 11 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 0.5L11 1.5L-4.37114e-08 1.5L0 0.5L11 0.5Z" fill="#111111"></path>
                                                        </svg>
                                                    </button>
                                                    <input class="quantity-item quantity__input quantity__input-product-group bg-unset 
                                                        border-none text-center width-50 appearance-none p-0-important 
                                                        product-detail__input" type="number" min="0" max="${variant.inventory}" data-type="${variant.productType}" 
                                                        data-index="${index}" id="Quantity-${variant.varId}" value="${variant.quantity}"
                                                        form="form-product-grouped">
                                                    <button class="btn-reset btn-add flex justify-content-center align-items-center quantity_button_custom no-js-hidden width-35" name="plus" id="custom-plus" type="button">
                                                        <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 11.5H6L6 6.5H11V5.5H6L6 0.5H5L5 5.5H0V6.5H5L5 11.5Z" fill="#111111"></path>
                                                        </svg>
                                                    </button>
                                                </quantity-input>
                                            </div>
                                        </div>
                                        
                                        <div class="custom-price">
                                            <div class="product-price">x&nbsp;₺${variant.price}</div>
                                        </div>
                                    </div>
                                </li>
                            `
        });
        return variantListHtml
    }

    renderLabels(inventory, quantity, needed) {
        if (inventory === 0) {
            return `<div class="danger-label">✗ Stokta yok. Lütfen farklı bir varyant seçiniz!</div>`
        } else {
            if (quantity > inventory) {
                return `<div class="secondary-label">Envanterde yeterli ürün yok!</div>`
            } else {
                if (quantity === inventory && needed > inventory) {
                    return `<div class="primary-label">Envanterdeki tüm stoğa ulaştınız.</div>`
                }
                if (needed > quantity) {
                    return `<div class="warning-label">Proje için ${(needed - quantity).toString()} adet daha ihtiyacınız olacak.</div>`
                }
                return `<div class="success-label">✓ Stokta var</div>`
            }
        }
    }

    getTotalPrice() {
        let total = 0;
        this.variantList.accessories?.forEach(acc => {
            total += acc.price * acc.quantity
        });
        this.variantList.others?.forEach(item => {
            total += item.price * item.quantity
        })
        return total
    }

    //* Only data fetching is universal, other functionalities are theme specific which varies theme to theme such as UI updates after fetching cart.json
    addToCart(event, variantList) {
        event.preventDefault();
        const target = event.currentTarget;
        let formData = {
            'items': [
            ]
        }

        // Loop through each product and create a promise to add it to the cart
        // Combine the others and accessories arrays
        const allVariants = [
            ...variantList.others,
            ...(variantList.accessories ? variantList.accessories : [])
        ];

        // Iterate over the combined array and push items with quantity > 0 to formData.items
        allVariants.forEach(item => {
            if (item.quantity > 0) {
                formData.items.push({
                    id: item.varId,
                    quantity: item.quantity
                });
            }
        });

        formData.items = formData.items.reduce((acc, item) => {
            const existingItem = acc.find(i => i.id === item.id);
            if (existingItem) {
                existingItem.quantity += item.quantity;
            } else {
                acc.push({ ...item });
            }
            return acc;
        }, []);

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart) {
            formData.sections = cart.getSectionsToRender().map((section) => section.id);
            formData.sections_url = window.location.pathname;
            // formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
            // formData.append('sections_url', window.location.pathname);
        }

        let openMiniCart = 0;
        if (formData.items.length > 0) {

            target.classList.add('btn-loading');
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    return response.json();
                }).then((state) => {
                    fetch('/cart.json')
                        .then(res => res.json())
                        .then(cart => {
                            document.querySelectorAll(".cart-count").forEach(el => {
                                if (el.classList.contains('cart-count-drawer')) {
                                    el.innerHTML = `(${cart.item_count})`;
                                } else {
                                    el.innerHTML = cart.item_count;
                                }
                            });
                            const cart_free_ship = document.querySelector("free-ship-progress-bar");
                            if (cart_free_ship) {
                                cart_free_ship.init(cart.items_subtotal_price);
                            }
                        })
                        .catch((error) => {
                            throw error;
                        });
                    if (state.message) {
                        const content = document.querySelector(".form-infor .add-cart-error");
                        if (!content) return;
                        var error_message = EasyDialogBox.create(
                            "add_cart_error",
                            "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
                            "",
                            content.innerHTML = state.description
                        );
                        error_message.onClose = error_message.destroy;
                        error_message.show();
                    } else {
                        openMiniCart = 1
                        cart.getSectionsToRender().forEach((section => {
                            const elementToReplace = document.getElementById(section.id);
                            const html = new DOMParser().parseFromString(state.sections[section.id], 'text/html');
                            elementToReplace.innerHTML = html.querySelector('#form-mini-cart').innerHTML;
                            const countdown = cart.querySelector('.cart-countdown-time');
                            const html_countdown = html.querySelector('.cart-countdown-time');
                            if (countdown && html_countdown) {
                                countdown.innerHTML = html_countdown.innerHTML;
                                cart.countdownTimer();
                            }
                        }));
                        cart.cartAction();
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                }).finally(() => {
                    target.classList.remove('btn-loading');
                    if (openMiniCart === 1) {
                        cart.open();
                    }
                    BlsLazyloadImg.init();
                });
        }
    }

    initializeModal() {

        let modalHtml = `
            <div id="custom-bundle-modal" class="modal" style="display:none">
                <div class="modal-content">
                    <span id="closeModalButton" class="close-button">&times;</span>
                    <div id="customBundleModalContent">Loading...</div>
                </div>
            </div>
        `
        document.body.insertAdjacentHTML("beforeend", modalHtml);

        this.modal = document.getElementById('custom-bundle-modal');

        const closeModalButton = document.getElementById('closeModalButton');
        closeModalButton.addEventListener('click', () => {
            this.modal.style.display = 'none'
        });

        window.addEventListener('click', (event) => {
            if (event.target === this.modal) {
                this.modal.style.display = 'none'
            }
        });
    }

    updateModalContent() {

        const selectedProduct = this.transformedData.find(product =>
            product.id === parseInt(this.selectedProductId)
        );
      console.log("this.selectedProductId", this.selectedProductId);
       console.log("selectedProduct", selectedProduct);
       console.log("this.transformedData", this.transformedData);

        this.selectedProductType = selectedProduct.productType;

        const selectedVariant = selectedProduct?.variants.find(variant =>
            variant.id === parseInt(this.selectedVariantId)
        );
      console.log("this.selectedVariantId", this.selectedVariantId);

        const modalContent = document.getElementById('customBundleModalContent');
        if (this.selectedProductId) {
            modalContent.innerHTML = `
                <div id="modalTitle">Seçenekler</div>
                    <div id="selected-color">Seçili: <span style="font-weight:bold">${selectedVariant.title}</span></div>
                    <div id="modalColorList">
                    ${selectedProduct.variants.map(variant => {
                return `<div class="custom-bundle-modal-image-container">
                                    <img class="custom-bundle-variant-img 
                                    ${variant.id === selectedVariant.id ? "selected-variant" : ""}
                                    ${variant.quantityAvailable === 0 ? "not-available" : ""}"
                                    src="${variant.image?.url ? variant.image.url : selectedProduct.featuredImage}" 
                                    data-variant-id="${variant.id}"
                                    />
                                    <div class="modal-variant-title">${variant.title}</div>
                                    ${variant.quantityAvailable === 0 ? `
                                        <div class="not-available-label">Stokta yok</div>
                                    ` : ""}
                                    
                                </div>
                                `}).join('')}</div>`
        } else {
            modalContent.innerHTML = `<p>Product not found.</p>`
        }

        const modalImages = document.querySelectorAll('.custom-bundle-variant-img')

        modalImages.forEach(img =>
            img.addEventListener('mouseenter', (e) => {
                const selectedVariantId = e.target.dataset.variantId;
                const selectedVariant = this.getVariantById(parseInt(selectedVariantId));
                console.log("selectedVariant", selectedVariant);

                if (selectedVariant.quantityAvailable === 0) {
                    // Prevent click action if inventory is 0
                    return;
                }
                modalImages.forEach(img => img.classList.contains('hovered-variant') ? img.classList.remove('hovered-variant') : null)
                e.target.classList.add('hovered-variant');

            }));
        modalImages.forEach(img => img.addEventListener('mouseleave', (e) => {
            const selectedVariantId = e.target.dataset.variantId;
            const selectedVariant = this.getVariantById(parseInt(selectedVariantId));

            if (selectedVariant.quantityAvailable === 0) {
                // Prevent click action if inventory is 0
                return;
            }
            e.target.classList.remove('hovered-variant');
        }));
        modalImages.forEach(img => img.addEventListener('click', (e) => {
            const selectedVariantId = e.target.dataset.variantId;
            const selectedVariant = this.getVariantById(parseInt(selectedVariantId));

            if (selectedVariant.quantityAvailable === 0) {
                // Prevent click action if inventory is 0
                return;
            }

            this.selectedVariantId = selectedVariantId;
            // Proceed with the rest of the logic
            modalImages.forEach(img => img.classList.contains('selected-variant') ? img.classList.remove('selected-variant') : null);
            this.selectedVariantId = selectedVariantId;
            e.target.classList.add('selected-variant');

            setTimeout(() => {
                this.modal.style.display = "none";
            }, 100);

            this.updateVariantList(this.selectedVariantIndex, selectedVariant);
        }));
    }

    // Set initial variant list state
    setVariantList(variantList) {
        // {id: variant id, quantity: selected quantity, needed: neededQuantity, inventory: availableForSale}
        this.variantList = variantList
    }

    getVariantById(id) {
        return this.transformedData
            .flatMap(product => product.variants)
            .find(variant =>
                variant.id === id
            );
    }

    getProductById(id) {
        return this.transformedData.find(product => product.id === id)
    }

    // Update variant list upon a selection of a variant such as color on modal
    updateVariantList(index, newVariant) {
        // Here new variant has the transformed shopify variant data structure
        const selectedProduct = this.getProductById(parseInt(this.selectedProductId));
        // Test for update method 2
        if (this.selectedProductType === "accessory") {
            this.variantList.accessories = this.variantList.accessories.map((accessory, i) => {
                if (i === Number(index)) {
                    return {
                        ...accessory,
                        varId: newVariant.id,
                        proId: selectedProduct.id,
                        inventory: newVariant.quantityAvailable,
                        productType: selectedProduct.productType,
                        varImg: newVariant.image.url,
                        proImg: selectedProduct.featuredImage,
                        proTitle: selectedProduct.title,
                        varTitle: newVariant.title,
                        price: Number(newVariant.price.amount),
                        compareAtPrice: newVariant.compareAtPrice?.amount || 0,
                        quantity: newVariant.quantityAvailable < accessory.quantity ? newVariant.quantityAvailable : Math.max(accessory.quantity, accessory.needed)
                    }
                } else {
                    return accessory
                }
            })
        } else {
            this.variantList.others = this.variantList.others.map((other, i) => {
                if (i === Number(index)) {
                    return {
                        ...other,
                        varId: newVariant.id,
                        proId: selectedProduct.id,
                        inventory: newVariant.quantityAvailable,
                        productType: selectedProduct.productType,
                        varImg: newVariant.image.url,
                        proImg: selectedProduct.featuredImage,
                        proTitle: selectedProduct.title,
                        varTitle: newVariant.title,
                        price: Number(newVariant.price.amount),
                        compareAtPrice: newVariant.compareAtPrice?.amount || 0,
                        quantity: newVariant.quantityAvailable < other.quantity ? newVariant.quantityAvailable : Math.max(other.quantity, other.needed)
                    }
                } else {
                    return other
                }
            })
        }

        this.renderBundle();
    }

    handleQuantityChange(index, newQuantity) {
      
        // Test for update method 2
        if (this.selectedProductType === "accessory") {
            this.variantList.accessories = this.variantList.accessories.map((accessory, i) => {
                if (i == index) {
                    return {
                        ...accessory,
                        quantity: newQuantity
                    }
                } else {
                    return accessory
                }
            });

        } else {
            this.variantList.others = this.variantList.others.map((variant, i) => {
                if (i == index) {
                    return {
                        ...variant,
                        quantity: newQuantity
                    }
                } else {
                    return variant
                }
            });

        }

      console.log("new this.variantList", this.variantList)

        this.renderBundle();
    }

    getTotalQuantity() {
        let totalQuantity = 0;
        this.variantList.accessories?.forEach(accessory => {
            totalQuantity += accessory.quantity
        });
        this.variantList.others?.forEach(variant => {
            totalQuantity += variant.quantity
        });
        return totalQuantity
    }

}

customElements.define("custom-pattern", CustomPattern);

function transformShopifyData(data) {
    return data.map(product => {
        return {
            id: product.id,
            handle: product.handle,
            title: product.title,
            featuredImage: product.featuredImage,
            productType: product.type,
            variants: product.variants
        }
    })
}

function prepareBundleData(data) {
  const bundleData = {}
  const transformedData = Object.values(
    data.reduce((acc, item) => {
      const {
        productId,
        productType,
        proImg,
        handle,
        proTitle,
        variantId,
        quantity,
        needed,
        inventory,
        varImg,
        compareAtPrice,
        price
      } = item;
  
      if (!acc[productId]) {
        // Create a new product entry
        acc[productId] = {
          id: productId,
          productType,
          image: proImg,
          handle,
          title: proTitle,
          variants: [],
        };
      }
  
      // Add variant to the product
      acc[productId].variants.push({
        id: variantId,
        quantity: (inventory >= needed) ? needed : inventory,
        quantityNeeded: needed,
        inventory,
        image: varImg,
        price,
        compareAtPrice
      });
  
      return acc;
    }, {})
  );
  bundleData.products = transformedData
  return bundleData
}
